<template>
  <div class="animated fadeIn">
    <b-card :no-body="true" class="mb-md-0 border-0">
      <b-card-body class="p-0 clearfix">
        <b-row>
          <b-col>
            <b-input-group class="mt-0">
              <template #prepend>
                <b-input-group-text>
                  <i :class="`fal ${icon} p-0 text-${variant}`" />
                </b-input-group-text>
              </template>
              <label class="custom-select text-muted" v-if="loading">
                <i class="fal fa-spinner p-0 fa-spin" />
                Loading...
              </label>
              <b-select v-else v-model="selected_value" :options="options" :disabled="disabled" />
            </b-input-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import BaseCollection from "@/collections/BaseCollection";

export default {
  name: "SelectFilter",
  props: {
    collection: {
      type: BaseCollection,
      default: () => null,
    },
    list: {
      type: Array,
      default: () => null,
    },
    directory: {
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    textKey: {
      type: String,
      default: "text",
    },
    valueKey: {
      type: String,
      default: "value",
    },
    selected: {
      type: [String, Number],
      default: null,
    },
    icon: {
      type: String,
      default: "fa-filter",
    },
    variant: {
      type: String,
      default: null,
    },
    filterField: {
      type: String,
      default: null,
    },
    filterOperator: {
      type: String,
      default: null,
    },
    filterLogic: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected_value: this.selected,
    };
  },
  computed: {
    options() {
      const default_options = [{ value: null, text: this.placeholder }];
      return this.collection && this.collection.models.length
        ? [
            ...default_options,
            ...this.collection.models.map((model) => {
              return {
                value: model[this.valueKey],
                text: model[this.textKey],
              };
            }),
          ]
        : this.list
        ? [...default_options, ...this.list]
        : this.directory
        ? [...default_options, ...this.directory]
        : [{ value: null, text: this.disabled ? this.placeholder : "Loading..." }];
    },
    loading() {
      return !this.disabled && this.options.length === 1;
    },
  },
  watch: {
    selected_value() {
      this.$emit("onSelect", {
        field: this.filterField,
        operator: this.filterOperator,
        value: this.selected_value,
        logic: this.filterLogic,
      });
    },
  },
};
</script>
